<!-- eslint-disable vue/html-self-closing -->
<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <div class="purchasing-order-add">
    <b-row class="purchasing-order__item match-height">
      <b-col>
        <b-card
          no-body
        >
          <b-card-header>
            <h4 class="mb-0">
              {{ $t('Customer Information') }}
            </h4>
          </b-card-header>
          <b-card-body>
            <div class="d-flex">
              <v-select
                v-model="model.customer"
                :options="customers"
                label="fullname_phone"
                :placeholder="$t('Search by phone number')"
                autocomplete
                class="w-100 mr-2"
                @search="searchCustomer"
              >
                <template #open-indicator>
                  <feather-icon icon="SearchIcon" />
                </template>
                <template #option="{ avatar, fullname_phone }">
                  <div class="d-flex align-items-center">
                    <b-avatar
                      class="mr-1"
                      :src="avatar"
                    />
                    <div>
                      <div class="text-nowrap">
                        {{ fullname_phone }}
                      </div>
                      <!-- <div class="text-nowrap">
                        {{ phone }}
                      </div> -->
                    </div>
                  </div>
                </template>
              </v-select>
              <b-button
                style="width: 130px;"
                @click="modalShow = !modalShow"
              >
                Thêm mới
              </b-button>
            </div>

            <div
              v-if="!model.customer"
              class="empty d-flex flex-column justify-content-center align-items-center"
              style="min-height: 207px; gap: 16px;"
            >
              <svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 58 46" aria-hidden="true" style="color: rgb(232, 234, 235); width: 87px;">
                <path d="M22.5257 22.9999C25.7869 22.9999 28.1924 20.5944 28.1924 17.3333C28.1924 14.0721 25.7869 11.6666 22.5257 11.6666C19.2646 11.6666 16.8591 14.0721 16.8591 17.3333C16.8591 20.5944 19.2617 22.9999 22.5257 22.9999Z" fill="currentColor"></path>
                <path d="M45.9998 14.4999H34.6665V20.1666H45.9998V14.4999Z" fill="currentColor"></path>
                <path d="M45.9998 25.8332H37.4998V31.4999H45.9998V25.8332Z" fill="currentColor"></path>
                <path d="M22.5257 25.1249C28.3028 25.1249 33.0515 30.4403 33.0515 34.3332H11.9998C11.9998 30.4403 16.7485 25.1249 22.5257 25.1249Z" fill="currentColor"></path>
                <path d="M51.6665 0.333252H6.33317C3.208 0.333252 0.666504 2.71608 0.666504 5.64575V40.3541C0.666504 43.2837 3.208 45.6666 6.33317 45.6666H51.6665C54.7917 45.6666 57.3332 43.2837 57.3332 40.3541V5.64575C57.3332 2.71608 54.7917 0.333252 51.6665 0.333252ZM51.6665 39.9999L6.33317 39.9688V5.99992L51.6665 6.03109V39.9999Z" fill="currentColor"></path>
              </svg>
              <div class="text">
                {{ $t('No customer information yet') }}
              </div>
            </div>
            <div
              v-else
              class="customer-info mt-2"
            >
              <div
                class="d-flex align-items-center flex-wrap mb-2"
              >
                <h5 class="mb-0">
                  {{ model.customer.fullname }}
                </h5>
                <span class="mx-1">-</span>
                <span>{{ model.customer.phone }}</span>
              </div>
              <div class="info-content">
                <div class="left">
                  <div class="d-flex flex-wrap align-items-center">
                    <h6 class="mb-0">
                      {{ $t('DELIVERY ADDRESS') }}
                    </h6>
                    <b-button
                      variant="flat-primary"
                      class="p-0 ml-1"
                      @click="modalEditAddress = !modalEditAddress"
                    >{{ $t('Change') }}</b-button>
                  </div>
                  <div>{{ model.customer.phone }}</div>
                  <div>{{ model.customer.address }}</div>
                </div>
                <!-- <div class="right bordered">
                  <div>{{ $t('Debts') }}</div>
                  <div class="d-flex justify-content-between">
                    <span>{{ $t('Total spending') }} (3 {{ $t('order') }})</span>
                    <span>1.145.000</span>
                  </div>
                  <div class="d-flex justify-content-between">
                    <span>{{ $t('Returns') }} (0 {{ $t('products') }})</span>
                    <span>0</span>
                  </div>
                  <div class="d-flex justify-content-between">
                    <span>{{ $t('Delivery failed') }} (0 {{ $t('order') }})</span>
                    <span>0</span>
                  </div>
                </div> -->
              </div>
              <b-collapse
                v-model="isInfoShow"
              >
                <div class="info-content">
                  <div class="left">
                    <div class="d-flex flex-wrap align-items-center">
                      <h6 class="mb-0">
                        {{ $t('ADDRESS TO RECEIVE BILLS') }}
                      </h6>
                      <b-button
                        variant="flat-primary"
                        class="p-0 ml-1"
                      >{{ $t('Change') }}</b-button>
                    </div>
                    <div>{{ model.customer.phone }}</div>
                    <div>{{ model.customer.address }}</div>
                  </div>
                  <div class="right">
                    <div class="d-flex flex-wrap align-items-center">
                      <h6 class="mb-0">
                        {{ $t('CONTACT') }}
                      </h6>
                      <b-button
                        variant="flat-primary"
                        class="p-0 ml-1"
                      >{{ $t('Add new') }}</b-button>
                    </div>
                    <div><small>{{ $t('No contact info yet') }}</small></div>
                    <b-form-input
                      placeholder="Email"
                    />
                  </div>
                </div>
              </b-collapse>
              <!-- <div class="text-center">
                <b-button
                  variant="flat-secondary"
                  class="p-0"
                  @click="isInfoShow = !isInfoShow"
                >
                  {{ isInfoShow ? $t('Collapse') : $t('Show more') }}
                </b-button>
              </div> -->
            </div>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col
        class="widget"
      >
        <b-card
          no-body
        >
          <b-card-header>
            <h4 class="mb-0">
              {{ $t('Additional information') }}
            </h4>
          </b-card-header>
          <b-card-body>
            <!-- <b-form-group
              :label="$t('Seller')"
            >
              <v-select
                v-model="model.seller"
                :options="sellers"
                :reduce="(option) => option.id"
                :clearable="false"
                label="fullname"
                class="v-select-custom"
              />
            </b-form-group> -->
            <!-- <b-form-group
              :label="$t('Seller')"
            >
              <b-form-input
                v-model="model.seller.fullname"
                readonly
              />
            </b-form-group> -->
            <!-- <b-form-group
              :label="$t('Sold at')"
            >
              <v-select
                v-model="model.branch"
                :options="branch"
                :reduce="(option) => option.id"
                :clearable="false"
                label="name"
                class="v-select-custom"
              />
            </b-form-group> -->
            <b-form-group
              :label="$t('Source')"
            >
              <v-select
                v-model="model.origin"
                :options="origins"
                :reduce="(option) => option.id"
                :clearable="false"
                label="name"
                class="v-select-custom"
              />
            </b-form-group>
            <b-form-group
              :label="$t('Delivery appointment')"
            >
              <flat-pickr
                v-model="model.delivery_date"
                class="form-control"
                :config="{'dateFormat': 'd-m-Y'}"
              />
            </b-form-group>
            <!-- <b-form-group
              :label="$t('Order ID')"
            >
              <b-form-input
                v-model="model.order_id"
              />
            </b-form-group> -->
            <!-- <b-form-group
              :label="$t('Channel order path')"
            >
              <b-form-input
                v-model="model.channel_order_path"
              />
            </b-form-group> -->
            <!-- <b-form-group
              :label="$t('Reference')"
            >
              <b-form-input
                v-model="model.reference"
              />
            </b-form-group> -->
            <b-form-group
              :label="$t('Payment method')"
            >
              <v-select
                v-model="model.payment_method"
                :options="paymentMethods"
                label="name"
                :reduce="(option) => option"
              />
            </b-form-group>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-card
      no-body
    >
      <b-card-header>
        <h4 class="mb-0">
          {{ $t('Product information') }}
        </h4>
      </b-card-header>
      <b-card-body>
        <v-select
          v-model="model.search"
          :options="products"
          label="name_full"
          :reduce="x => x"
          :placeholder="$t('Search by product name')"
          autocomplete
          @search="searchProduct"
          @input="setProduct(model.search)"
        >
          <template #open-indicator>
            <feather-icon icon="SearchIcon" />
          </template>
          <template #option="{ avatar, name, name_variant, sku, price, inventory, can_sell }">
            <div class="d-flex justify-content-between bd-b-1">
              <div class="d-flex align-items-center">
                <b-avatar
                  class="mr-1"
                  square
                  :src="avatar"
                />
                <div>
                  <div class="text-nowrap">
                    {{ name }}
                  </div>
                  <small class="darken-1">
                    {{ sku }} <small class="text-info ml-1">{{ name_variant }}</small>
                  </small>
                </div>
              </div>
              <div class="text-right">
                <div class="font-weight-bolder">
                  {{ unitFormatOriginal(price) }}
                </div>
                <div>
                  <span>{{ $t('Inventory') }}: <span class="text-info">{{ inventory }}</span></span>
                  <span class="mx-1">|</span>
                  <span>{{ $t('Can be sold') }}: <span class="text-info">{{ can_sell }}</span></span>
                </div>
              </div>
            </div>
          </template>
        </v-select>

        <!-- Empty products -->
        <div
          v-if="model.products.length === 0"
          class="d-flex flex-column justify-content-center align-items-center text-center"
          style="height: 236px;"
        >
          <svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 102 102" aria-hidden="true" style="color: rgb(232, 234, 235); height: 102px; width: 102px;"><path d="M93.0836 53.7204L83.87 40.1573L93.0836 26.5943C93.5152 25.9469 93.6149 25.1334 93.3658 24.403C93.1168 23.6725 92.5358 23.0915 91.8053 22.8425L61.7575 12.8818C60.6784 12.5166 59.5163 12.9316 58.9021 13.8613L51 25.7144L43.1145 13.8779C42.4837 12.9316 41.3216 12.5332 40.2591 12.8984L10.2113 22.8591C9.48082 23.1081 8.89978 23.6725 8.65077 24.4196C8.40175 25.15 8.50136 25.9635 8.93299 26.6109L18.13 40.1573L8.91638 53.7204C8.48476 54.3678 8.38515 55.1813 8.63417 55.9117C8.88318 56.6422 9.46422 57.2232 10.1947 57.4722L40.2425 67.4328C41.305 67.7815 42.4837 67.3996 43.0979 66.4534L50.9834 54.6168L58.8689 66.4534C59.4997 67.3996 60.6784 67.7815 61.7243 67.4328L91.7721 57.4722C92.5026 57.2232 93.0836 56.6588 93.3326 55.9117C93.6148 55.1813 93.5152 54.3678 93.0836 53.7204ZM51 47.495L28.987 40.1573L51 32.8197L73.013 40.1573L51 47.495Z" fill="currentColor"></path><path d="M63.3169 72.1474C60.1793 73.1933 56.6433 72.0644 54.7342 69.209L50.999 63.5813L47.2471 69.209C45.3546 72.0644 41.802 73.2099 38.6478 72.1474L18.627 65.4738V79.9997C18.627 81.0787 19.3076 82.025 20.3369 82.357L50.2021 92.3176C50.2851 92.3508 50.3847 92.3674 50.4677 92.4006C50.6504 92.4338 50.8164 92.4504 50.999 92.4504C51.1816 92.4504 51.3642 92.4338 51.5634 92.384C51.6464 92.3674 51.7294 92.3508 51.8124 92.3176L81.6777 82.357C82.6904 82.025 83.3876 81.0621 83.3876 79.9997V65.4572L63.3169 72.1474Z" fill="currentColor"></path></svg>
          <small>{{ $t('No product information yet') }}</small>
        </div>

        <!-- Table: Products -->
        <vue-good-table
          v-else
          ref="promotion-products"
          class="custom-good-table my-2"
          style-class="vgt-table"
          :columns="productFields"
          :rows="model.products"
          :search-options="{
            enabled: false
          }"
          :pagination-options="{
            enabled: false,
            perPage:pageLength
          }"
        >
          <!-- Table: Head -->
          <template
            slot="table-column"
            slot-scope="props"
          >
            <span class="text-nowrap">
              {{ $t(props.column.label) }}
            </span>
          </template>

          <!-- Table: Rows -->
          <template
            slot="table-row"
            slot-scope="props"
          >
            <!-- Column: Product Name -->
            <span
              v-if="props.column.field === 'name'"
              class="d-flex"
            >
              <b-avatar
                class="mr-1"
                square
                size="lg"
                :src="props.row.avatar"
              />
              <div
                class="d-flex flex-column"
                style="max-width: 350px;"
              >
                <span>{{ props.row.name }}</span>
                <!-- <span>{{ props.row.variant }}</span>
                <span>{{ props.row.sku }}</span> -->
              </div>
            </span>

            <!-- Column: Quantity -->
            <span
              v-if="props.column.field === 'quantity'"
            >
              <b-form-spinbutton
                v-model="model.products[props.row.originalIndex].quantity"
                min="1"
                :max="model.products[props.row.originalIndex].can_sell"
                @input="changeValue"
              />
              <span
                v-if="model.products[props.row.originalIndex].quantity === model.products[props.row.originalIndex].can_sell"
              >
                SL có thể đặt: {{ model.products[props.row.originalIndex].can_sell }}
              </span>
            </span>

            <!-- Column: Price -->
            <span
              v-if="props.column.field === 'price'"
              class="d-block text-center"
            >
              <!-- <b-form-input
                v-model="props.row.price"
                class="text-right"
                style="max-width: 100px;"
              /> -->
              {{ unitFormatOriginal(props.row.price) }}
            </span>

            <!-- Column: Discount -->
            <span
              v-if="props.column.field === 'discount_price'"
              style="position: relative"
            >
              <b-form-input
                v-model="model.products[props.row.originalIndex].discount_price"
                class="text-right"
                style="max-width: 100px;"
                min="0"
                type="number"
                @input="changeValue"
              />
              <!-- <span
                v-if="props.row.newprice && props.row.newprice > 0"
                class="text-danger"
                style="position: absolute; top: 25%; right: 0;"
              >{{ Math.ceil((props.row.newprice / props.row.price * 100)) }}%</span> -->
            </span>

            <!-- Column: Temp Price -->
            <span
              v-if="props.column.field === 'temp_price'"
              class="d-block text-center"
            >
              {{ unitFormatOriginal((model.products[props.row.originalIndex].price * model.products[props.row.originalIndex].quantity) - (model.products[props.row.originalIndex].quantity * model.products[props.row.originalIndex].discount_price)) }}
            </span>

            <!-- Column: Actions -->
            <span
              v-if="props.column.field === 'actions'"
              class="d-block text-center"
            >
              <b-button
                variant="flat-danger rounded-circle"
                class="btn-icon"
                @click="removeProduct(props.row.id)"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </span>
          </template>

          <!-- pagination -->
          <!-- <template
            slot="pagination-bottom"
            slot-scope="props"
          >
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap ">
                  Showing 1 to
                </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['10','30','100']"
                  class="mx-1"
                  @input="(value)=>props.perPageChanged({currentPerPage:value})"
                />
                <span class="text-nowrap"> of {{ props.total }} entries </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value)=>props.pageChanged({currentPage:value})"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template> -->
        </vue-good-table>

        <!-- Purchasing Order More Information -->
        <div class="purchasing-order__product-info">
          <div class="left">
            <b-form-group
              :label="$t('Order notes')"
            >
              <b-form-textarea
                v-model="model.note"
                placeholder=""
                rows="3"
              />
            </b-form-group>
          </div>

          <div class="right">
            <div class="block">
              <div class="d-flex justify-content-between align-items-center">
                <span>{{ $t('Total amount') }} ({{ model.products.length }} {{ $t('products') }})</span>
                <span>{{ unitFormatOriginal(subTotalPrice) }}</span>
              </div>
              <!-- <div class="d-flex justify-content-between align-items-center">
                <span>{{ $t('Discount') }}</span>
                <span>
                  <b-form-input />
                </span>
              </div> -->
              <div class="d-flex justify-content-between align-items-center">
                <span>{{ $t('Delivery charges') }}</span>
                <span class="v-input-mark">
                  <!-- {{unitFormatOriginal(fee)}} -->
                  <!-- <b-form-input v-model="fee" /> -->
                  <b-form-input v-model.number="fee" />
                  <!-- <input
                    v-model.number="fee"
                    type="number"
                    class="v-true form-control"
                    @input="mixFixVal(fee, 'money')"
                  >
                  <input
                    :value="unitFormatOriginal(fee)"
                    class="v-false form-control"
                    readonly
                    tab-index="-1"
                  > -->
                </span>
              </div>
              <!-- <div class="d-flex justify-content-between align-items-center">
                <span>{{ $t('Discount code') }}</span>
                <span>
                  <b-form-input />
                </span>
              </div> -->
              <div class="d-flex justify-content-between align-items-center">
                <span
                  class="text-primary cursor-pointer"
                  @click="modalSurcharge = !modalSurcharge"
                >{{ $t('Phụ phí') }}</span>
                <span>{{ unitFormatOriginal(totalSurchargeFinal) }}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span>{{ $t('Customer must pay') }}</span>
                <span>{{ unitFormatOriginal(customerPay) }}</span>
              </div>
            </div>
            <div class="block">
              <div class="d-flex justify-content-between align-items-center">
                <span>{{ $t('Customer paid') }}</span>
                <span>{{ unitFormatOriginal(customerPayed) }}</span>
              </div>
            </div>
            <div class="block">
              <div class="d-flex justify-content-between">
                <span>{{ $t('Remaining') }}</span>
                <span>{{ unitFormatOriginal(totalPriceFinal) }}</span>
              </div>
            </div>
            <b-button @click="handlerSubmitOrder">
              Tạo đơn
            </b-button>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <!-- <b-card>
      <b-card-header class="justify-content-start">
        <h4 class="mb-0 mr-1">{{ $t('Packing and delivery') }}</h4>
        <b-button
          :disabled="model.products.length > 0 && model.payment_method && model.customer ? false : true"
          @click="getFeeShip"
        >
          Lấy thông tin vận chuyển
        </b-button>
      </b-card-header>
      <b-card-body v-if="!shippingHidden">
        <b-tabs
          pills
        >
          <div active>
            <template #title>
              <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" style="width: 24px;"><path d="M17.4532 9.32275C17.2244 9.10384 16.8532 9.10384 16.6243 9.32275L14.007 11.8261L13.0006 10.8635C12.7718 10.6446 12.4006 10.6446 12.1717 10.8635C11.9428 11.0824 11.9428 11.4374 12.1717 11.6564L13.5926 13.0154C13.7071 13.1249 13.8571 13.1796 14.0071 13.1796C14.157 13.1796 14.3071 13.1249 14.4215 13.0154L17.4532 10.1156C17.6821 9.89667 17.6821 9.54169 17.4532 9.32275Z" fill="currentColor" stroke="currentColor" stroke-width="0.5"></path><path d="M20.4422 5H9.30753C8.44858 5 7.74975 5.66841 7.74975 6.48997V7.83273H4.44078C3.09492 7.83273 2 8.88 2 10.1672V16.1018C2 16.8269 2.61676 17.4168 3.37484 17.4168H4.53195C4.80027 18.5705 5.87808 19.4359 7.16394 19.4359C8.44979 19.4359 9.52756 18.5705 9.79592 17.4168H14.1976C14.466 18.5705 15.5438 19.4359 16.8296 19.4359C18.1154 19.4359 19.1932 18.5705 19.4616 17.4168H20.4422C21.3012 17.4168 22 16.7484 22 15.9269V6.48997C22 5.66841 21.3011 5 20.4422 5ZM4.53195 16.2961H3.37484C3.26281 16.2961 3.17172 16.209 3.17172 16.1019V10.1672C3.17172 9.49789 3.74101 8.95341 4.44082 8.95341H7.74979V14.3391C7.56104 14.2989 7.36515 14.277 7.16394 14.277C5.87812 14.2771 4.80031 15.1425 4.53195 16.2961ZM7.16394 18.3152C6.323 18.3152 5.63882 17.6608 5.63882 16.8565C5.63882 16.0522 6.323 15.3978 7.16394 15.3978C8.00487 15.3978 8.68905 16.0522 8.68905 16.8565C8.68905 17.6608 8.00487 18.3152 7.16394 18.3152ZM16.8296 18.3152C15.9887 18.3152 15.3046 17.661 15.3045 16.8568C15.3045 16.8567 15.3045 16.8566 15.3045 16.8565C15.3045 16.8565 15.3045 16.8564 15.3045 16.8563C15.3047 16.0521 15.9888 15.3978 16.8296 15.3978C17.6705 15.3978 18.3547 16.0522 18.3547 16.8565C18.3547 17.6608 17.6705 18.3152 16.8296 18.3152ZM20.4422 16.2961H19.4615C19.1932 15.1425 18.1154 14.2771 16.8295 14.2771C15.5438 14.2771 14.4659 15.1425 14.1976 16.2961H9.79592C9.6676 15.7446 9.35432 15.2593 8.92151 14.9026V6.48997C8.92151 6.28638 9.09467 6.12072 9.30756 6.12072H20.4422C20.655 6.12072 20.8282 6.28635 20.8282 6.48997V15.9269H20.8282C20.8282 16.1305 20.6551 16.2961 20.4422 16.2961Z" fill="currentColor" stroke="currentColor" stroke-width="0.5"></path></svg>
              <span>{{ $t('Thông tin người nhận và gói hàng') }}</span>
            </template>

            <div class="shipping-info mt-1">
              <div class="shipping-info-card">
                <div class="d-flex flex-wrap align-items-center mb-1">
                  <h6 class="mb-0">{{ $t('Delivery address') }}</h6>
                  <b-button
                    variant="flat-primary"
                    class="p-0 ml-1"
                    @click="modalEditAddress = !modalEditAddress"
                  >{{ $t('Change') }}</b-button>
                </div>

                <div class="mb-1">
                  <div>{{ infoOrder.customerName }}</div>
                  <div>{{ infoOrder.customerPhone }}</div>
                  <div>{{ infoOrder.customerAddress }}</div>
                </div>

                <div class="mb-1">
                  <h6>{{ $t('Shipping information') }}</h6>
                  <b-form-group
                    :label="$t('COD')"
                  >
                    <b-form-input v-model="infoOrder.cod" readonly />
                  </b-form-group>
                  <b-form-group
                    :label="`${$t('Weigh')} (g)`"
                  >
                    <b-form-input v-model="infoOrder.weight" readonly />
                  </b-form-group>
                  <b-row>
                    <b-col>
                      <b-form-group
                        :label="`${$t('Longs')} (cm)`"
                      >
                        <b-form-input v-model="infoOrder.length" readonly />
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group
                        :label="`${$t('Width')} (cm)`"
                      >
                        <b-form-input v-model="infoOrder.width" readonly />
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group
                        :label="`${$t('Height')} (cm)`"
                      >
                        <b-form-input v-model="infoOrder.height" readonly />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-form-group
                    :label="$t('Note')"
                  >
                    <b-form-textarea
                      v-model="infoOrder.note"
                      :placeholder="$t('Note')"
                      rows="3"
                    />
                  </b-form-group>
                </div>
              </div>
              <div class="shipping-info-content">
                <div class="noti-card">
                  <svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 119 109" aria-hidden="true" style="width: 120px; height: 120px; color: rgb(232, 234, 235);"><path d="M109.083 60.0913V83.4734C109.083 84.9473 107.747 86.1715 106.138 86.1715H103.859C104.054 85.3081 104.172 84.4076 104.172 83.4734C104.172 76.0268 97.5736 69.9831 89.4437 69.9831C81.3139 69.9831 74.7157 76.0268 74.7157 83.4734C74.7157 84.2289 74.7931 84.9473 74.9514 85.6319C74.2076 85.1665 73.7363 84.3739 73.7363 83.4734V45.7005C73.7363 44.2267 75.0729 43.0024 76.6819 43.0024H90.4268C100.718 43.0024 109.083 50.665 109.083 60.0913Z" fill="currentColor"></path><path d="M89.4438 93.3688C83.4864 93.3688 78.6445 88.9338 78.6445 83.477C78.6445 78.0201 83.4864 73.5852 89.4438 73.5852C95.4013 73.5852 100.243 78.0201 100.243 83.477C100.243 88.9305 95.4013 93.3688 89.4438 93.3688Z" fill="currentColor"></path><path d="M33.479 93.3686C27.5215 93.3686 22.6797 88.9336 22.6797 83.4768C22.6797 78.02 27.5215 73.5884 33.479 73.5884C39.4364 73.5884 44.2783 78.02 44.2783 83.4734C44.2783 88.9269 39.4364 93.3686 33.479 93.3686Z" fill="currentColor"></path><path d="M9.91602 57.417C9.91602 58.7424 11.0906 59.8216 12.5413 59.8216H49.2692C50.7162 59.8216 51.8944 58.7458 51.8944 57.417V40.5979H9.91602V57.417Z" fill="currentColor"></path><path d="M21.9525 37.3905H29.1508V18.1667H18.6644C17.5782 18.1667 16.6062 18.7772 16.2159 19.7013L10.0891 34.1191C9.97861 34.3821 9.9197 34.6621 9.91602 34.942V37.3905H12.5413H21.9525Z" fill="currentColor"></path><path d="M51.716 34.1191L45.5928 19.7013C45.2025 18.7772 44.2342 18.1667 43.148 18.1667H32.6543V37.3905H39.8526H49.2711H51.8927V34.9386C51.889 34.6621 51.8301 34.3821 51.716 34.1191Z" fill="currentColor"></path><path d="M66.8638 32.2104H57.2243C57.5778 33.0502 57.7656 33.9338 57.784 34.8444V35.2019V57.4205C57.784 61.7206 53.9658 65.2179 49.2676 65.2179H14.8262V83.4737C14.8262 84.9475 16.1627 86.1718 17.7718 86.1718H19.0605C18.8653 85.3084 18.7475 84.4079 18.7475 83.4737C18.7475 76.0271 25.3456 69.9834 33.4755 69.9834C41.6053 69.9834 48.2035 76.0271 48.2035 83.4737C48.2035 84.4079 48.0856 85.3084 47.8905 86.1718H66.8601C68.4692 86.1718 69.8057 84.9475 69.8057 83.4737V34.9085C69.8094 33.4347 68.4765 32.2104 66.8638 32.2104Z" fill="currentColor"></path></svg>
                  <div class="d-flex flex-column">
                    <strong>{{ $t('Please enter full shipping information to choose a shipping company') }}</strong>
                    <span>- {{ $t('The delivery address is missing address information. Please update information here') }}</span>
                    <div
                      v-for="(item, index) in feeShip"
                      :key="item.id"
                      class="d-flex justify-content-between align-items-center p-2 mt-1 css-shipping"
                      :class="feeShippingSelected && feeShippingSelected.id === item.id ? 'active' : ''"
                      @click="setShipping(index)"
                    >
                      <div>
                        <img class="mr-2" width="130" :src="item.avatar" alt="GHN">
                        <span>{{ item.name }}</span>
                      </div>
                      <div v-if="item.status === 1">
                        {{ item.fee }}
                      </div>
                      <div v-else>Chưa kết nối</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <b-tab>
            <template #title>
              <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" style="width: 24px;"><path d="M19 7C19 5.9 18.1 5 17 5H14V7H17V9.65L13.52 14H10V9H6C3.79 9 2 10.79 2 13V16H4C4 17.66 5.34 19 7 19C8.66 19 10 17.66 10 16H14.48L19 10.35V7ZM4 14V13C4 11.9 4.9 11 6 11H8V14H4ZM7 17C6.45 17 6 16.55 6 16H8C8 16.55 7.55 17 7 17Z" fill="currentColor"></path><path d="M5 6H10V8H5V6ZM19 13C17.34 13 16 14.34 16 16C16 17.66 17.34 19 19 19C20.66 19 22 17.66 22 16C22 14.34 20.66 13 19 13ZM19 17C18.45 17 18 16.55 18 16C18 15.45 18.45 15 19 15C19.55 15 20 15.45 20 16C20 16.55 19.55 17 19 17Z" fill="currentColor"></path></svg>
              <span>{{ $t('Call the shipper yourself') }}</span>
            </template>

            <div class="shipping-info mt-1">
              <div class="shipping-info-card">
                <div class="d-flex flex-wrap align-items-center mb-1">
                  <h6>{{ $t('Delivery address') }}</h6>
                  <b-button
                    variant="flat-primary"
                    class="p-0 ml-1"
                  >{{ $t('Change') }}</b-button>
                </div>

                <div class="mb-1">
                  <div>0935240482</div>
                  <div>Quảng Bình, Quận Ba Đình, Hà Nội</div>
                </div>

                <div class="mb-1">
                  <h6 class="mb-0">{{ $t('Shipping information') }}</h6>
                  <b-form-group
                    :label="$t('COD')"
                  >
                    <b-form-input />
                  </b-form-group>
                  <b-form-group
                    :label="`${$t('Weigh')} (g)`"
                  >
                    <b-form-input />
                  </b-form-group>
                  <b-row>
                    <b-col>
                      <b-form-group
                        :label="`${$t('Longs')} (cm)`"
                      >
                        <b-form-input />
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group
                        :label="`${$t('Width')} (cm)`"
                      >
                        <b-form-input />
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group
                        :label="`${$t('Height')} (cm)`"
                      >
                        <b-form-input />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-form-group
                    :label="$t('Delivery order')"
                  >
                    <v-select
                      v-model="requestDeliverySelected"
                      :options="requestDelivery"
                    />
                  </b-form-group>
                  <b-form-group
                    :label="$t('Note')"
                  >
                    <b-form-textarea
                      :placeholder="$t('Note')"
                      rows="3"
                    />
                  </b-form-group>
                </div>
              </div>
              <div class="shipping-info-content">
                <div class="noti-card">
                  <svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 119 109" aria-hidden="true" style="width: 120px; height: 120px; color: rgb(232, 234, 235);"><path d="M109.083 60.0913V83.4734C109.083 84.9473 107.747 86.1715 106.138 86.1715H103.859C104.054 85.3081 104.172 84.4076 104.172 83.4734C104.172 76.0268 97.5736 69.9831 89.4437 69.9831C81.3139 69.9831 74.7157 76.0268 74.7157 83.4734C74.7157 84.2289 74.7931 84.9473 74.9514 85.6319C74.2076 85.1665 73.7363 84.3739 73.7363 83.4734V45.7005C73.7363 44.2267 75.0729 43.0024 76.6819 43.0024H90.4268C100.718 43.0024 109.083 50.665 109.083 60.0913Z" fill="currentColor"></path><path d="M89.4438 93.3688C83.4864 93.3688 78.6445 88.9338 78.6445 83.477C78.6445 78.0201 83.4864 73.5852 89.4438 73.5852C95.4013 73.5852 100.243 78.0201 100.243 83.477C100.243 88.9305 95.4013 93.3688 89.4438 93.3688Z" fill="currentColor"></path><path d="M33.479 93.3686C27.5215 93.3686 22.6797 88.9336 22.6797 83.4768C22.6797 78.02 27.5215 73.5884 33.479 73.5884C39.4364 73.5884 44.2783 78.02 44.2783 83.4734C44.2783 88.9269 39.4364 93.3686 33.479 93.3686Z" fill="currentColor"></path><path d="M9.91602 57.417C9.91602 58.7424 11.0906 59.8216 12.5413 59.8216H49.2692C50.7162 59.8216 51.8944 58.7458 51.8944 57.417V40.5979H9.91602V57.417Z" fill="currentColor"></path><path d="M21.9525 37.3905H29.1508V18.1667H18.6644C17.5782 18.1667 16.6062 18.7772 16.2159 19.7013L10.0891 34.1191C9.97861 34.3821 9.9197 34.6621 9.91602 34.942V37.3905H12.5413H21.9525Z" fill="currentColor"></path><path d="M51.716 34.1191L45.5928 19.7013C45.2025 18.7772 44.2342 18.1667 43.148 18.1667H32.6543V37.3905H39.8526H49.2711H51.8927V34.9386C51.889 34.6621 51.8301 34.3821 51.716 34.1191Z" fill="currentColor"></path><path d="M66.8638 32.2104H57.2243C57.5778 33.0502 57.7656 33.9338 57.784 34.8444V35.2019V57.4205C57.784 61.7206 53.9658 65.2179 49.2676 65.2179H14.8262V83.4737C14.8262 84.9475 16.1627 86.1718 17.7718 86.1718H19.0605C18.8653 85.3084 18.7475 84.4079 18.7475 83.4737C18.7475 76.0271 25.3456 69.9834 33.4755 69.9834C41.6053 69.9834 48.2035 76.0271 48.2035 83.4737C48.2035 84.4079 48.0856 85.3084 47.8905 86.1718H66.8601C68.4692 86.1718 69.8057 84.9475 69.8057 83.4737V34.9085C69.8094 33.4347 68.4765 32.2104 66.8638 32.2104Z" fill="currentColor"></path></svg>
                  <div class="d-flex flex-column">
                    <strong>{{ $t('Please enter full shipping information to choose a shipping company') }}</strong>
                    <span>- {{ $t('The delivery address is missing address information. Please update information here') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>

          <b-tab>
            <template #title>
              <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" style="width: 24px;"><path d="M20 11.242V18H21V20H1V18H2V11.242C1.38437 10.8311 0.879713 10.2745 0.53082 9.62176C0.181927 8.96899 -0.000407734 8.24017 6.84612e-07 7.5C6.84612e-07 6.673 0.224001 5.876 0.633001 5.197L3.345 0.5C3.43277 0.347985 3.559 0.221749 3.71101 0.133981C3.86303 0.0462129 4.03547 4.45922e-06 4.211 0H17.79C17.9655 4.45922e-06 18.138 0.0462129 18.29 0.133981C18.442 0.221749 18.5682 0.347985 18.656 0.5L21.358 5.182C21.9546 6.17287 22.1463 7.35553 21.8934 8.48414C21.6405 9.61275 20.9624 10.6005 20 11.242ZM18 11.972C17.3124 12.0491 16.6163 11.9665 15.9659 11.7307C15.3155 11.4948 14.7283 11.1119 14.25 10.612C13.8302 11.0511 13.3258 11.4005 12.7672 11.6393C12.2086 11.878 11.6075 12.001 11 12.001C10.3927 12.0013 9.7916 11.8786 9.23303 11.6402C8.67445 11.4018 8.16996 11.0527 7.75 10.614C7.27163 11.1138 6.68437 11.4964 6.03395 11.7321C5.38353 11.9678 4.68749 12.0503 4 11.973V18H18V11.973V11.972ZM4.789 2L2.356 6.213C2.11958 6.79714 2.11248 7.44903 2.33613 8.03818C2.55978 8.62733 2.99768 9.11029 3.56218 9.39039C4.12668 9.6705 4.77614 9.72708 5.38058 9.54882C5.98502 9.37055 6.49984 8.9706 6.822 8.429C7.157 7.592 8.342 7.592 8.678 8.429C8.8633 8.89342 9.1836 9.2916 9.59753 9.5721C10.0115 9.85261 10.5 10.0025 11 10.0025C11.5 10.0025 11.9885 9.85261 12.4025 9.5721C12.8164 9.2916 13.1367 8.89342 13.322 8.429C13.657 7.592 14.842 7.592 15.178 8.429C15.3078 8.74845 15.5022 9.0376 15.7491 9.27828C15.996 9.51895 16.2901 9.70595 16.6127 9.82752C16.9354 9.94909 17.2797 10.0026 17.6241 9.98468C17.9684 9.96677 18.3053 9.87782 18.6136 9.72343C18.9219 9.56903 19.1949 9.35253 19.4155 9.08753C19.6361 8.82253 19.7995 8.51477 19.8955 8.18357C19.9914 7.85238 20.0178 7.50493 19.973 7.16305C19.9281 6.82118 19.8131 6.49227 19.635 6.197L17.21 2H4.79H4.789Z" fill="currentColor"></path></svg>
              <span>{{ $t('Pick up at the store') }}</span>
            </template>
          </b-tab>

          <b-tab>
            <template #title>
              <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" style="width: 24px;"><path d="M20 11.242V18H21V20H1V18H2V11.242C1.38437 10.8311 0.879713 10.2745 0.53082 9.62176C0.181927 8.96899 -0.000407734 8.24017 6.84612e-07 7.5C6.84612e-07 6.673 0.224001 5.876 0.633001 5.197L3.345 0.5C3.43277 0.347985 3.559 0.221749 3.71101 0.133981C3.86303 0.0462129 4.03547 4.45922e-06 4.211 0H17.79C17.9655 4.45922e-06 18.138 0.0462129 18.29 0.133981C18.442 0.221749 18.5682 0.347985 18.656 0.5L21.358 5.182C21.9546 6.17287 22.1463 7.35553 21.8934 8.48414C21.6405 9.61275 20.9624 10.6005 20 11.242ZM18 11.972C17.3124 12.0491 16.6163 11.9665 15.9659 11.7307C15.3155 11.4948 14.7283 11.1119 14.25 10.612C13.8302 11.0511 13.3258 11.4005 12.7672 11.6393C12.2086 11.878 11.6075 12.001 11 12.001C10.3927 12.0013 9.7916 11.8786 9.23303 11.6402C8.67445 11.4018 8.16996 11.0527 7.75 10.614C7.27163 11.1138 6.68437 11.4964 6.03395 11.7321C5.38353 11.9678 4.68749 12.0503 4 11.973V18H18V11.973V11.972ZM4.789 2L2.356 6.213C2.11958 6.79714 2.11248 7.44903 2.33613 8.03818C2.55978 8.62733 2.99768 9.11029 3.56218 9.39039C4.12668 9.6705 4.77614 9.72708 5.38058 9.54882C5.98502 9.37055 6.49984 8.9706 6.822 8.429C7.157 7.592 8.342 7.592 8.678 8.429C8.8633 8.89342 9.1836 9.2916 9.59753 9.5721C10.0115 9.85261 10.5 10.0025 11 10.0025C11.5 10.0025 11.9885 9.85261 12.4025 9.5721C12.8164 9.2916 13.1367 8.89342 13.322 8.429C13.657 7.592 14.842 7.592 15.178 8.429C15.3078 8.74845 15.5022 9.0376 15.7491 9.27828C15.996 9.51895 16.2901 9.70595 16.6127 9.82752C16.9354 9.94909 17.2797 10.0026 17.6241 9.98468C17.9684 9.96677 18.3053 9.87782 18.6136 9.72343C18.9219 9.56903 19.1949 9.35253 19.4155 9.08753C19.6361 8.82253 19.7995 8.51477 19.8955 8.18357C19.9914 7.85238 20.0178 7.50493 19.973 7.16305C19.9281 6.82118 19.8131 6.49227 19.635 6.197L17.21 2H4.79H4.789Z" fill="currentColor"></path></svg>
              <span>{{ $t('Delivery later') }}</span>
            </template>

            <b-row class="mt-1">
              <b-col md="6">
                <b-form-group
                  :label="$t('You can pre-select your expected delivery partner to facilitate order processing')"
                >
                  <v-select
                    v-model="deliveryPartnerSelected"
                    :options="deliveryPartners"
                    :placeholder="$t('Select a partner')"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-card-body>
    </b-card> -->
    <b-modal
      id="modal-list"
      v-model="modalShow"
      size="lg"
      scrollable
      title="Tạo mới khách hàng"
    >
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <b-col md="12">
              <Fieldset id="information" :title="$t('Infomation General')">
                <b-row>
                  <b-col cols="6">
                    <b-form-group :label="`*` + $t('Full name') + `:`" label-cols-md="12">
                      <validation-provider
                        #default="{ errors }"
                        name="Full name"
                        rules="required"
                      >
                        <b-form-input
                          v-model="modelCustomer.fullname"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="$t('Full name')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                    <b-form-group :label="`*` + $t('Phone') + `:`" label-cols-md="12">
                      <validation-provider
                        #default="{ errors }"
                        name="phone"
                        rules="required"
                      >
                        <b-form-input
                          v-model="modelCustomer.phone"
                          :state="errors.length > 0 ? false : null"
                          type="number"
                          placeholder="Phone"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group label="*Email:" label-cols-md="12">
                      <validation-provider
                        #default="{ errors }"
                        name="Email"
                        rules="required"
                      >
                        <b-form-input
                          v-model="modelCustomer.email"
                          :state="errors.length > 0 ? false : null"
                          type="text"
                          placeholder="Email"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                    <b-form-group
                      :label="$t('Delivery appointment')"
                    >
                      <b-form-input
                        v-model="modelCustomer.birthday"
                        type="date"
                        placeholder="dd/mm/YYYY"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-form-group :label="`*` + $t('Gender') + `:`" label-cols-md="12">
                  <div class="d-flex align-items-center">
                    <b-form-radio v-model="modelCustomer.gender" :value="0">
                      {{ $t('Male') }}
                    </b-form-radio>
                    <b-form-radio v-model="modelCustomer.gender" :value="1" class="ml-3">
                      {{ $t('Female') }}
                    </b-form-radio>
                  </div>
                </b-form-group>
                <b-form-group :label="`*` + $t('Address') + `:`" label-cols-md="12">
                  <validation-provider
                    #default="{ errors }"
                    name="Address"
                    rules="required"
                  >
                    <b-form-input
                      v-model="modelCustomer.address"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="$t('Address')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-row>
                  <b-col cols="12">
                    <b-form-group :label="$t('Province/City')" label-cols-md="12">
                      <v-select
                        v-model="modelCustomer.province"
                        label="name"
                        :reduce="x => x"
                        :options="provinceOptions"
                        :placeholder="$t('Province/City')"
                      />
                    </b-form-group>
                    <b-form-group :label="$t('District')" label-cols-md="12">
                      <v-select
                        v-model="modelCustomer.district"
                        label="name"
                        :reduce="x => x"
                        :options="districtOptions"
                        :placeholder="$t('District')"
                      />
                    </b-form-group>
                    <b-form-group :label="$t('Wards')" label-cols-md="12">
                      <v-select
                        v-model="modelCustomer.wards"
                        label="name"
                        :reduce="x => x"
                        :options="wardsOptions"
                        :placeholder="$t('Wards')"
                      />
                    </b-form-group>
                    <span>{{ generalAddressFull() }}</span>
                  </b-col>
                </b-row>
                <b-form-group :label="$t('Company')" label-cols-md="12">
                  <validation-provider
                    #default="{ errors }"
                    name="Company"
                  >
                    <b-form-input
                      v-model="modelCustomer.company"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="$t('Company')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group :label="$t('Address for issuing red invoice')" label-cols-md="12">
                  <validation-provider
                    #default="{ errors }"
                    name="Address"
                  >
                    <b-form-input
                      v-model="modelCustomer.address_red"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="$t('Address')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-row>
                  <b-col cols="6">
                    <b-form-group :label="$t('Tax code')" label-cols-md="12">
                      <validation-provider
                        #default="{ errors }"
                        name="taxcode"
                      >
                        <b-form-input
                          v-model="modelCustomer.taxcode"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="$t('Tax code')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group :label="$t('ID number')" label-cols-md="12">
                      <validation-provider
                        #default="{ errors }"
                        name="idnumb"
                      >
                        <b-form-input
                          v-model="modelCustomer.idnumb"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="$t('ID number')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </Fieldset>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <template #modal-footer>
        <div class="d-flex justify-content-between">
          <div class="text-danger">
            {{ modelCustomer.error }}
          </div>
          <b-button variant="primary" @click.prevent="handlerSubmitCustomer">
            Tạo mới
          </b-button>
        </div>
        <!-- <b-button variant="danger" @click="cancel()">
          Đóng
        </b-button> -->
      </template>
    </b-modal>
    <!-- set new shipping address -->
    <b-modal
      v-if="model.customer"
      id="modal-list"
      v-model="modalEditAddress"
      size="lg"
      scrollable
      title="Thêm địa chỉ giao hàng mới"
      @ok="handlerSubmitAddress"
    >
      <validation-observer ref="simpleRulesAddress">
        <b-form @submit.prevent>
          <b-row>
            <b-col md="12">
              <Fieldset id="information" :title="$t('Infomation General')">
                <b-row>
                  <b-col cols="6">
                    <b-form-group :label="`*` + $t('Full name') + `:`" label-cols-md="12">
                      <validation-provider
                        #default="{ errors }"
                        name="Full name"
                        rules="required"
                      >
                        <b-form-input
                          v-model="addressShipping.fullname"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="$t('Full name')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group :label="`*` + $t('Phone') + `:`" label-cols-md="12">
                      <validation-provider
                        #default="{ errors }"
                        name="phone"
                        rules="required"
                      >
                        <b-form-input
                          v-model="addressShipping.phone"
                          :state="errors.length > 0 ? false : null"
                          type="number"
                          placeholder="Phone"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </Fieldset>
              <Fieldset id="information-2" :title="$t('Address')">
                <b-form-group :label="`*` + $t('Address') + `:`" label-cols-md="12">
                  <validation-provider
                    #default="{ errors }"
                    name="Address"
                    rules="required"
                  >
                    <b-form-input
                      v-model="addressShipping.address"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="$t('Address')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-row>
                  <b-col cols="12">
                    <b-form-group :label="$t('Province/City')" label-cols-md="12">
                      <v-select
                        v-model="addressShipping.province"
                        label="name"
                        :reduce="x => x"
                        :options="provinceOptions"
                        :placeholder="$t('Province/City')"
                      />
                    </b-form-group>
                    <b-form-group :label="$t('District')" label-cols-md="12">
                      <v-select
                        v-model="addressShipping.district"
                        label="name"
                        :reduce="x => x"
                        :options="districtOptions"
                        :placeholder="$t('District')"
                      />
                    </b-form-group>
                    <b-form-group :label="$t('Wards')" label-cols-md="12">
                      <v-select
                        v-model="addressShipping.wards"
                        label="name"
                        :reduce="x => x"
                        :options="wardsOptions"
                        :placeholder="$t('Wards')"
                      />
                    </b-form-group>
                    <span>{{ generalAddressFull() }}</span>
                  </b-col>
                </b-row>
              </Fieldset>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>
    <!-- surcharge -->
    <b-modal
      id="modal-surcharge"
      ref="modal-surcharge"
      v-model="modalSurcharge"
      title="Thêm phụ phí cho đơn hàng"
      cancel-variant="outline-secondary"
      size="lg"
      no-close-on-backdrop
    >
      <b-card-text>
        <div class="d-flex justify-content-between">
          <h5>Tổng phụ phí:</h5>
          <div class="price-modal text-primary">
            {{ unitFormatOriginal(totalSurcharge) }}
          </div>
        </div>
        <div class="list-payment mt-1">
          <div class="d-flex justify-content-between mb-1">
            <!-- <b-form-checkbox
              v-model="modelPayment.is_money"
              name="is_money"
            >
              Tiền mặt
            </b-form-checkbox> -->
            <!-- <div
              v-if="modelPayment.is_money"
              class="v-input-mark"
            >
              <input
                v-model.number="modelPayment.money"
                type="number"
                class="v-true form-control"
                @input="mixFixVal(modelPayment, 'money')"
              >
              <input
                :value="unitFormatOriginal(modelPayment.money)"
                class="v-false form-control"
                readonly
                tab-index="-1"
              >
            </div> -->
            <!-- <b-form-input  v-model.number="modelPayment.money" class="w-175px" /> -->
          </div>
          <div class="mb-1">
            <!-- <b-form-checkbox
              v-model="modelPayment.is_bank"
              name="is_bank"
            >
              Chuyển khoản
            </b-form-checkbox> -->
            <div
              class="group-pay-bank"
            >
              <div
                v-for="(item, index) in modelSurcharge.list"
                :key="index"
                class="d-flex justify-content-between align-items-center ml-2 mt-1"
              >
                <v-select
                  v-model="modelSurcharge.list[index]"
                  :options="surchargeOptions"
                  label="name"
                  input-id="invoice-data-client"
                  :clearable="false"
                  class="w-50"
                  placeholder="Chọn phụ phí"
                  @input="handleSelectedSurcharge(modelSurcharge.list[index], index)"
                >
                  <template #list-header>
                    <div
                      class="add-new-client-header d-flex align-items-center my-50"
                      tag="li"
                      @click="opBank(index)"
                    >
                      <feather-icon icon="PlusIcon" size="16" />
                      <span class="align-middle ml-50">{{ $t('Thêm phụ phí') }}</span>
                    </div>
                  </template>
                </v-select>
                <div class="d-flex justify-content-between align-items-center w-50">
                  <!-- <b-form-input v-model.number="modelSurcharge.list[index].money" class="mx-1" /> -->
                  <div
                    class="v-input-mark mx-1"
                  >
                    <b-form-input
                      v-model="modelSurcharge.list[index].money"
                    />
                    <!-- <input
                      v-model.number="modelSurcharge.list[index].money"
                      type="number"
                      class="v-true form-control"
                      @input="mixFixVal(modelSurcharge.list[index], 'money')"
                    >
                    <input
                      :value="unitFormatOriginal(modelSurcharge.list[index].money)"
                      class="v-false form-control"
                      readonly
                      tab-index="-1"
                    > -->
                  </div>
                  <feather-icon class="cursor-pointer" icon="XIcon" @click="handleDelete(index)" />
                </div>
              </div>
              <div class="text-primary mt-2 ml-2">
                <span class="cursor-pointer" @click="handleAddPay">+ Thêm phụ phí</span>
              </div>
            </div>
          </div>
          <div v-if="modelAddSurcharge.show" class="form-add-bank">
            <b-row>
              <b-col md="6">
                <b-form-input
                  v-model="modelAddSurcharge.name"
                  :placeholder="$t('Tên phụ phí')"
                  class="mb-1"
                />
              </b-col>
              <b-col md="6">
                <b-form-input
                  v-model="modelAddSurcharge.money"
                  :placeholder="$t('Số tiền')"
                  class="mb-1"
                />
              </b-col>
            </b-row>
            <b-button
              variant="outline-secondary"
              size="sm"
              class="mr-1"
              @click="modelAddSurcharge.show = false"
            >
              {{ $t('Quay lại') }}
            </b-button>
            <b-button
              variant="secondary"
              size="sm"
              @click="addSurcharge()"
            >
              {{ $t('Thêm') }}
            </b-button>
          </div>
        </div>
      </b-card-text>

      <template #modal-footer="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button variant="primary" @click="okSurcharge()">
          Xác nhận
        </b-button>
        <b-button variant="danger" @click="cancel()">
          Đóng
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
/** eslint-disable-next-line array-callback-return */
import {
  BButton,
  BAvatar,
  BCard,
  BCardHeader,
  BCardBody,
  VBTooltip,
  BFormInput,
  BFormTextarea,
  BFormGroup,
  // BFormSelect,
  // BPagination,
  // BBadge,
  // BProgress,
  BCollapse,
  BRow,
  BCol,
  // BTabs,
  // BTab,
  BFormSpinbutton,
  BFormRadio,
  BForm,
  VBToggle,
  BCardText,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import flatPickr from 'vue-flatpickr-component'
import { VueGoodTable } from 'vue-good-table'
import VSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Request from '@/plugins/service/index'
// import { timer } from 'rxjs'

export default {
  components: {
    flatPickr,
    VueGoodTable,
    BButton,
    BAvatar,
    BCard,
    BCardHeader,
    BCardBody,
    BFormInput,
    BFormTextarea,
    BFormGroup,
    // BFormSelect,
    // BPagination,
    // BBadge,
    // BProgress,
    BCollapse,
    BRow,
    BCol,
    // BTabs,
    // BTab,
    BFormSpinbutton,
    BFormRadio,
    BForm,
    ValidationProvider,
    ValidationObserver,
    VSelect,
    BCardText,
  },
  directives: {
    'b-tooltip': VBTooltip,
    'b-toggle': VBToggle,
  },
  props: {},

  data() {
    return {
      required,
      dateConfig: {
        dateFormat: 'd-m-Y',
      },
      customers: [],
      sellers: [
        {
          id: 1,
          name: 'Phan Cao Huân',
        },
        {
          id: 2,
          name: 'Cao Huân Phan',
        },
      ],
      branch: [
        {
          id: 1,
          name: 'Chi nhánh mặc định',
        },
      ],
      origins: [
        {
          id: 1,
          name: 'Web',
        },
        {
          id: 2,
          name: 'Tiktok shop',
        },
        {
          id: 3,
          name: 'Facebook',
        },
        {
          id: 4,
          name: 'Instagram',
        },
      ],
      paymentMethods: [
        {
          id: 1,
          name: 'COD',
        },
        {
          id: 2,
          name: 'Chuyển khoản',
        },
      ],
      productFields: [
        { field: 'name', label: 'Products', sortable: true },
        { field: 'quantity', label: 'Quantity', sortable: false },
        { field: 'price', label: 'Price', sortable: false },
        { field: 'discount_price', label: 'Discount price', sortable: false },
        { field: 'temp_price', label: 'Total', sortable: false },
        { field: 'actions', label: 'Actions', sortable: false },
      ],
      products: [
        {
          id: 1,
          name: 'Áo khoác phối sọc cá tính SID62366 - Freesize',
          sku: 'PVN01',
          price: 135000,
          variant: 'Đen',
          discount_price: 0,
          discount_percent: 0,
          avatar: 'https://sapo.dktcdn.net/100/639/802/variants/eccbcbe2-8ae9-4c8d-9e22-353a201e9700.jpg',
          quantity: 1,
          inventory: 25,
          can_sell: 25,
        },
        {
          id: 2,
          name: 'Áo khoác cổ tim phong cách tripal SID50074 - Freesize',
          sku: 'PVN02',
          price: 180000,
          variant: 'Freesize',
          discount_price: 0,
          discount_percent: 0,
          avatar: 'https://sapo.dktcdn.net/100/639/802/variants/01_96c626bf20e5454bab6cf2550107a044_master-1657079379161.jpg',
          quantity: 1,
          inventory: 47,
          can_sell: 47,
        },
        {
          id: 3,
          name: 'Áo khoác cổ tim phong cách tripal SID50074 - Freesize',
          sku: 'PVN03',
          price: 277000,
          variant: 'Freesize',
          discount_price: 0,
          discount_percent: 0,
          avatar: 'https://sapo.dktcdn.net/100/639/802/variants/fd5e8a7d-fcf3-49dc-91dc-bb65067e1ecf.jpg',
          quantity: 1,
          inventory: 125,
          can_sell: 85,
        },
        {
          id: 4,
          name: 'Áo khoác đầm dáng xòe nút bọc 2in1 SID55675 - Hồng',
          sku: 'PVN04',
          price: 520000,
          variant: 'Hồng',
          discount_price: 0,
          discount_percent: 0,
          avatar: 'https://sapo.dktcdn.net/100/639/802/variants/6a6ff5ac-b79c-4929-bb2d-5f576c2f9339.jpg',
          quantity: 1,
          inventory: 83,
          can_sell: 83,
        },
      ],
      productsSelected: [],
      requestDelivery: [
        'Cho xem hàng, cho thử',
        'Cho xem hàng, không cho thử',
        'Không cho xem hàng',
      ],
      requestDeliverySelected: 'Cho xem hàng, cho thử',
      isInfoShow: false,
      pageLength: 10,
      deliveryPartners: [
        'Giao hàng nhanh',
        'Giao hàng tiết kiệm',
      ],
      deliveryPartnerSelected: null,
      model: {
        seller: JSON.parse(localStorage.getItem('token')),
        branch: 1,
        origin: 1,
        delivery_date: null,
        order_id: null,
        channel_order_path: null,
        reference: null,
        payment_method: {
          id: 1,
          name: 'COD',
        },
        customer: null,
        products: [],
        search: null,
        note: null,
      },
      searchType: 1,
      modalShow: false,
      modalEditAddress: false,
      // module add customer by modal
      modelCustomer: {
        birthday: null,
        address: null,
        province: null,
        district: null,
        wards: null,
        gender: 0,
      },
      addressShipping: {
        province: null,
        district: null,
        wards: null,
      },
      provinceOptions: [],
      districtOptions: [],
      wardsOptions: [],
      modelShipping: {
        province_id: null,
        district_id: null,
        wards_id: null,
      },
      infoOrder: {
        customerName: '',
        customerPhone: '',
        customerAddress: '',
        cod: 0,
        weight: 300,
        height: 5,
        width: 15,
        length: 25,
        note: '',
      },
      feeShip: [
        {
          id: 1,
          name: 'Giao hàng nhanh',
          avatar: '/ghn.svg',
          fee: 0,
          status: 1,
        },
        {
          id: 2,
          name: 'Giao hàng tiết kiệm',
          avatar: '/ghtk.png',
          fee: 0,
          status: 1,
        },
      ],
      feeShippingSelected: null,
      fee: 0,
      subTotalPrice: 0,
      customerPay: 0,
      customerPayed: 0,
      totalPriceFinal: 0,
      shippingHidden: false,
      // phụ phí
      surchargeOptions: [],
      modalSurcharge: false,
      modelSurcharge: {
        is_use: false,
        list: [],
      },
      modelAddSurcharge: {
        show: false,
        id: null,
        name: null,
        money: 0,
        index: null,
      },
      selectedSurcharge: null,
      totalSurcharge: 0,
      totalSurchargeFinal: 0,
      timeout: null,
      storage: {},
    }
  },
  computed: {
    // totalPrice() {
    //   const init = 0
    //   let sum = 0
    //   if (this.model.products.length > 0) {
    //     // eslint-disable-next-line arrow-body-style
    //     sum = this.model.products.reduce((prev, cur) => {
    //       return prev + (cur.price * cur.quantity - cur.discount_price)
    //     }, init)
    //   }
    //   return sum
    // },
  },
  watch: {
    // eslint-disable-next-line object-shorthand
    'model.products'() {
      this.totalPrice()
    },
    fee() {
      this.totalPrice()
    },
    // eslint-disable-next-line object-shorthand
    'modelCustomer.province'() {
      this.loadDistrict(this.modelCustomer.province.id)
    },
    // eslint-disable-next-line object-shorthand
    'modelCustomer.district'() {
      this.loadWards(this.modelCustomer.district.id)
    },
    // eslint-disable-next-line object-shorthand
    'addressShipping.province'() {
      this.loadDistrict(this.addressShipping.province.id)
    },
    // eslint-disable-next-line object-shorthand
    'addressShipping.district'() {
      this.loadWards(this.addressShipping.district.id)
    },
    // eslint-disable-next-line object-shorthand
    'model.payment_method'() {
      this.totalPrice()
    },
    // eslint-disable-next-line object-shorthand
    'modelSurcharge.list'() {
      this.getTotalSurcharge()
    },
    // eslint-disable-next-line object-shorthand
    // 'model.customer'() {
    //   this.getDetailCustomer()
    // },
  },
  async created() {
    this.modelbankJson = JSON.stringify(this.modelAddSurcharge)
    await this.getStorage()
    this.loadCustomers()
    this.loadUsers()
    this.loadProductVariants()
    this.loadProvince()
    this.getSurcharge()
  },
  methods: {
    changeValue() {
      this.totalPrice()
    },
    async getStorage() {
      const res = await this.mixGet('/storages', { limit: 1000 })
      if (res.status) {
        if (res.data) {
          this.storage = res.data.items.find(x => x.is_default === 1)
        }
      }
    },
    totalPrice() {
      this.subTotalPrice = 0
      this.customerPay = 0
      this.customerPayed = 0
      this.totalPriceFinal = 0
      if (this.model.products.length > 0) {
        // eslint-disable-next-line arrow-body-style, array-callback-return
        this.model.products.map(cur => {
          this.subTotalPrice += ((cur.price * cur.quantity) - (cur.quantity * cur.discount_price))
        })
      }
      this.customerPay = this.subTotalPrice + this.fee + this.totalSurchargeFinal
      if (!this.model.payment_method) {
        this.totalPriceFinal = this.subTotalPrice + this.fee
      } else if (this.model.payment_method.id === 1) {
        this.totalPriceFinal = this.subTotalPrice + this.fee + this.totalSurchargeFinal
        this.customerPayed = 0
      } else {
        this.totalPriceFinal = 0
        this.customerPayed = this.subTotalPrice + this.fee + this.totalSurchargeFinal
      }
      // if (this.modelSurcharge.is_use) {
      //   this.totalPriceFinal += this.totalSurchargeFinal
      // }
    },
    getTotalSurcharge() {
      this.totalSurcharge = 0
      // eslint-disable-next-line no-return-assign
      this.modelSurcharge.list.map(item => this.totalSurcharge += Number(item.money))
    },
    generalAddressFull() {
      let string = ''
      if (this.modelCustomer.address) string += `${this.modelCustomer.address}`
      if (this.modelCustomer.wards) string += `, ${this.modelCustomer.wards.name}`
      if (this.modelCustomer.district) string += `, ${this.modelCustomer.district.name}`
      if (this.modelCustomer.province) string += `, ${this.modelCustomer.province.name}`
      return string
    },
    removeProduct(id) {
      this.model.products.splice(this.model.products.findIndex(item => item.id === id), 1)
    },
    async loadCustomers() {
      const siteId = JSON.parse(localStorage.getItem('siteID')).id
      try {
        const res = await Request.get(
          this.$http,
          `${process.env.VUE_APP_API_URL}/customers?site_id=${siteId}&sort[]=created_at,desc`,
        )
        if (res.status === 200) {
          if (res.data.status) {
            const list = await this.getDataTranslation(
              res.data.data.items,
              true,
            )
            // eslint-disable-next-line array-callback-return
            list.map(item => {
              const find = item.delivery_address.find(x => x.is_default === 1)
              if (find) {
                this.customers.push({
                  address: item.address,
                  address_full: find.address,
                  avatar: item.avatar,
                  birthday: item.birthday,
                  email: item.email,
                  fullname: `${item.fullname}`,
                  fullname_phone: `${item.fullname} - ${item.phone}`,
                  gender: item.gender,
                  id: item.id,
                  id_number: item.id_number,
                  is_active: item.is_active,
                  phone: item.phone,
                  province_name: find.province.name,
                  district_name: find.district.name,
                  wards_name: find.ward.name,
                  delivery_address_id: find.id,
                })
              }
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Opps! Something wrong',
                icon: 'AlertOctagonIcon',
                variant: 'danger',
                text: String(this.showError(res.data.error, ',')),
              },
            })
          }
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Opps! Something wrong',
            icon: 'AlertOctagonIcon',
            variant: 'danger',
            text: String(error),
          },
        })
      }
    },
    async loadUsers() {
      const res = await this.mixGet('/v2/users')
      if (res.status) {
        this.sellers = await this.getDataTranslation(
          res.data.items,
          true,
        )
      }
    },
    async searchCustomer(data, loading) {
      // eslint-disable-next-line no-use-before-define
      clearTimeout(this.timeout)
      this.timeout = setTimeout(async () => {
        loading(true)
        const res = await this.mixGet('/customers', { fullname: data, 'sort[]': 'created_at,desc' })
        if (res.status) {
          this.customers = []
          // eslint-disable-next-line array-callback-return
          res.data.items.map(item => {
            const find = item.delivery_address.find(x => x.is_default === 1)
            if (find) {
              this.customers.push({
                address: item.address,
                address_full: find.address,
                avatar: item.avatar,
                birthday: item.birthday,
                email: item.email,
                fullname: `${item.fullname}`,
                fullname_phone: `${item.fullname} - ${item.phone}`,
                gender: item.gender,
                id: item.id,
                id_number: item.id_number,
                is_active: item.is_active,
                phone: item.phone,
                province_name: find.province.name,
                district_name: find.district.name,
                wards_name: find.ward.name,
                delivery_address_id: find.id,
              })
            }
          })
          loading(false)
        }
      }, 500)
    },
    async searchProduct(data, loading) {
      // eslint-disable-next-line no-use-before-define
      clearTimeout(this.timeout)
      this.timeout = setTimeout(async () => {
        loading(true)
        const param = {
          name: data,
          'sort[]': 'id,desc',
        }
        const res = await this.mixGet('/storages_warehouses', param)
        if (res.status) {
          const list = await this.getDataTranslation(
            res.data.items,
            true,
          )
          const temp = []
          // eslint-disable-next-line array-callback-return
          list.map(item => {
            if (item.quantity - item.keep_stock > 0) {
              temp.push({
                id: item.id,
                product_id: item.warehouse.product_id,
                warehouse_id: item.warehouse.id,
                avatar: item.warehouse.avatar,
                // name: item.warehouse.product ? item.warehouse.product.name : '--',
                attribute: (item.warehouse.name_attribute),
                name: `${item.warehouse.product.name} - ${item.warehouse.name_attribute[0] ? item.warehouse.name_attribute[0].value : ''}${item.warehouse.name_attribute[1] ? ` / ${item.warehouse.name_attribute[1].value}` : ''}${item.warehouse.name_attribute[2] ? ` / ${item.warehouse.name_attribute[2].value}` : ''} - ${item.warehouse.sku}`,
                name_full: `${item.warehouse.product.name} - ${item.warehouse.name_attribute[0] ? item.warehouse.name_attribute[0].value : ''}${item.warehouse.name_attribute[1] ? ` / ${item.warehouse.name_attribute[1].value}` : ''}${item.warehouse.name_attribute[2] ? ` / ${item.warehouse.name_attribute[2].value}` : ''} - ${item.warehouse.sku}`,
                name_variant: `${item.warehouse.name_attribute[0] ? item.warehouse.name_attribute[0].value : ''}${item.warehouse.name_attribute[1] ? ` / ${item.warehouse.name_attribute[1].value}` : ''}${item.warehouse.name_attribute[2] ? ` / ${item.warehouse.name_attribute[2].value}` : ''}`,
                barcode: item.warehouse.barcode,
                sku: item.warehouse.sku,
                price: item.warehouse.price,
                newprice: 0,
                discount_price: 0,
                stock: item.stock || '--',
                inventory: item.quantity || '--',
                can_sell: item.quantity - item.keep_stock,
                quantity: 1,
                weight: item.warehouse.product.weight,
                height: item.warehouse.product.height,
                width: item.warehouse.product.width,
                length: item.warehouse.product.length,
              })
              // temp[index].name = `${item.warehouse.product.name} - ${temp[index].attribute[0] ? temp[index].attribute[0].value : ''}${temp[index].attribute[1] ? ` / ${temp[index].attribute[1].value}` : ''}${temp[index].attribute[2] ? ` / ${temp[index].attribute[2].value}` : ''}`
              // temp[index].name_full = `${item.warehouse.product.name} - ${temp[index].attribute[0] ? temp[index].attribute[0].value : ''}${temp[index].attribute[1] ? ` / ${temp[index].attribute[1].value}` : ''}${temp[index].attribute[2] ? ` / ${temp[index].attribute[2].value}` : ''} - ${item.warehouse.sku}`
            }
            // temp.push({
            //   id: item.id,
            //   product_id: item.warehouse.product_id,
            //   warehouse_id: item.warehouse.id,
            //   avatar: item.warehouse.avatar,
            //   attribute: JSON.parse(item.warehouse.name_attribute),
            //   name: '',
            //   name_full: '',
            //   barcode: item.warehouse.barcode,
            //   sku: item.warehouse.sku,
            //   price: item.warehouse.price,
            //   newprice: 0,
            //   discount_price: 0,
            //   stock: item.stock || '--',
            //   inventory: item.quantity || '--',
            //   can_sell: item.quantity - item.keep_stock,
            //   quantity: 1,
            //   weight: item.warehouse.product.weight,
            //   height: item.warehouse.product.height,
            //   width: item.warehouse.product.width,
            //   length: item.warehouse.product.length,
            // })
            // temp[index].name = `${item.warehouse.product.name} - ${temp[index].attribute[0] ? temp[index].attribute[0].value : ''}${temp[index].attribute[1] ? ` / ${temp[index].attribute[1].value}` : ''}${temp[index].attribute[2] ? ` / ${temp[index].attribute[2].value}` : ''}`
            // temp[index].name_full = `${item.warehouse.product.name} - ${temp[index].attribute[0] ? temp[index].attribute[0].value : ''}${temp[index].attribute[1] ? ` / ${temp[index].attribute[1].value}` : ''}${temp[index].attribute[2] ? ` / ${temp[index].attribute[2].value}` : ''} - ${item.warehouse.sku}`
          })
          this.products = temp
          loading(false)
        }
      }, 500)
      loading(false)
    },
    setProduct(data) {
      const find = this.model.products.findIndex(x => x.id === data.id)
      if (find < 0) {
        this.model.products.push(data)
      } else {
        this.model.products[find].quantity += 1
      }
      this.model.search = null
    },
    async loadProductVariants() {
      const res = await this.mixGet('/storages_warehouses', { storages_id: this.storage.id_number, 'sort[]': 'id,desc', limit: 40 })
      if (res.status) {
        const list = await this.getDataTranslation(
          res.data.items,
          true,
        )
        const temp = []
        // eslint-disable-next-line array-callback-return
        list.map(item => {
          if (item.quantity - item.keep_stock > 0) {
            temp.push({
              id: item.id,
              product_id: item.warehouse.product_id,
              warehouse_id: item.warehouse.id,
              avatar: item.warehouse.avatar,
              // name: item.warehouse.product ? item.warehouse.product.name : '--',
              attribute: (item.warehouse.name_attribute),
              name: `${item.warehouse.product.name} - ${item.warehouse.name_attribute[0] ? item.warehouse.name_attribute[0].value : ''}${item.warehouse.name_attribute[1] ? ` / ${item.warehouse.name_attribute[1].value}` : ''}${item.warehouse.name_attribute[2] ? ` / ${item.warehouse.name_attribute[2].value}` : ''} - ${item.warehouse.sku}`,
              name_full: `${item.warehouse.product.name} - ${item.warehouse.name_attribute[0] ? item.warehouse.name_attribute[0].value : ''}${item.warehouse.name_attribute[1] ? ` / ${item.warehouse.name_attribute[1].value}` : ''}${item.warehouse.name_attribute[2] ? ` / ${item.warehouse.name_attribute[2].value}` : ''} - ${item.warehouse.sku}`,
              name_variant: `${item.warehouse.name_attribute[0] ? item.warehouse.name_attribute[0].value : ''}${item.warehouse.name_attribute[1] ? ` / ${item.warehouse.name_attribute[1].value}` : ''}${item.warehouse.name_attribute[2] ? ` / ${item.warehouse.name_attribute[2].value}` : ''}`,
              barcode: item.warehouse.barcode,
              sku: item.warehouse.sku,
              price: item.warehouse.price,
              newprice: 0,
              discount_price: 0,
              stock: item.stock || '--',
              inventory: item.quantity || '--',
              can_sell: item.quantity - item.keep_stock,
              quantity: 1,
              weight: item.warehouse.product.weight,
              height: item.warehouse.product.height,
              width: item.warehouse.product.width,
              length: item.warehouse.product.length,
            })
            // temp[index].name = `${item.warehouse.product.name} - ${temp[index].attribute[0] ? temp[index].attribute[0].value : ''}${temp[index].attribute[1] ? ` / ${temp[index].attribute[1].value}` : ''}${temp[index].attribute[2] ? ` / ${temp[index].attribute[2].value}` : ''}`
            // temp[index].name_full = `${item.warehouse.product.name} - ${temp[index].attribute[0] ? temp[index].attribute[0].value : ''}${temp[index].attribute[1] ? ` / ${temp[index].attribute[1].value}` : ''}${temp[index].attribute[2] ? ` / ${temp[index].attribute[2].value}` : ''} - ${item.warehouse.sku}`
          }
          // temp.push({
          //   id: item.id,
          //   product_id: item.warehouse.product_id,
          //   warehouse_id: item.warehouse.id,
          //   avatar: item.warehouse.avatar,
          //   attribute: JSON.parse(item.warehouse.name_attribute),
          //   name: '',
          //   name_full: '',
          //   barcode: item.warehouse.barcode,
          //   sku: item.warehouse.sku,
          //   price: item.warehouse.price,
          //   newprice: 0,
          //   discount_price: 0,
          //   stock: item.stock || '--',
          //   inventory: item.quantity || '--',
          //   can_sell: item.quantity - item.keep_stock,
          //   quantity: 1,
          //   weight: item.warehouse.product.weight,
          //   height: item.warehouse.product.height,
          //   width: item.warehouse.product.width,
          //   length: item.warehouse.product.length,
          // })
          // temp[index].name = `${item.warehouse.product.name} - ${temp[index].attribute[0] ? temp[index].attribute[0].value : ''}${temp[index].attribute[1] ? ` / ${temp[index].attribute[1].value}` : ''}${temp[index].attribute[2] ? ` / ${temp[index].attribute[2].value}` : ''}`
          // temp[index].name_full = `${item.warehouse.product.name} - ${temp[index].attribute[0] ? temp[index].attribute[0].value : ''}${temp[index].attribute[1] ? ` / ${temp[index].attribute[1].value}` : ''}${temp[index].attribute[2] ? ` / ${temp[index].attribute[2].value}` : ''} - ${item.warehouse.sku}`
        })
        this.products = temp
      }
    },
    async handlerSubmitCustomer() {
      // eslint-disable-next-line consistent-return
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
          try {
            if (this.modelCustomer.address === null || this.modelCustomer.province === null || this.modelCustomer.district === null || this.modelCustomer.wards === null) {
              this.modelCustomer.error = 'Vui lòng điền đầy đủ mục Địa chỉ'
              return false
            }
            this.modelCustomer.error = ''
            const params = {
              site_id: JSON.parse(localStorage.getItem('siteID')).id,
              gender: Number(this.modelCustomer.gender) ?? 0,
              is_active: Number(this.modelCustomer.is_active === true ? 1 : 0),
              birthday: this.modelCustomer.birthday,
              email: this.modelCustomer.email,
              phone: this.modelCustomer.phone,
              fullname: this.modelCustomer.fullname,
              address: this.modelCustomer.address,
              address_full: `${this.modelCustomer.address}, ${this.modelCustomer.wards.name}, ${this.modelCustomer.district.name}, ${this.modelCustomer.province.name}`,
              province: this.modelCustomer.province.id,
              district: this.modelCustomer.district.id,
              ward: this.modelCustomer.wards.id,
              is_default: 1,
              is_delivery: 1,
            }
            const res = await Request.post(
              this.$http,
              `${process.env.VUE_APP_API_URL}/customers`,
              params,
            )
            if (res.status === 200) {
              if (res.data.status) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Congratulation !',
                    icon: 'CheckCircleIcon',
                    variant: 'success',
                    text: 'Create Customer success',
                  },
                })
                this.loadCustomers()
                this.modalShow = false
              } else {
                this.modalShow = true
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Opps! Something wrong',
                    icon: 'AlertOctagonIcon',
                    variant: 'danger',
                    text: String(this.showError(res.data.error, ',')),
                  },
                })
              }
            }
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Opps! Something wrong',
                icon: 'AlertOctagonIcon',
                variant: 'danger',
                text: String(error),
              },
            })
          }
        }
      })
    },
    async loadProvince() {
      const res = await this.mixGet('/provinces', { limit: 64 })
      if (res.status) {
        // eslint-disable-next-line array-callback-return
        res.data.items.map(item => {
          this.provinceOptions.push({
            ...item,
            name: `${item.prefix} ${item.name}`,
          })
        })
      }
    },
    async loadDistrict(provinceID = null) {
      let param = {}
      if (provinceID) {
        param = {
          limit: 200,
          province_id: provinceID,
        }
      }
      const res = await this.mixGet('/districts', param)
      if (res.status) {
        // eslint-disable-next-line array-callback-return
        res.data.items.map(item => {
          this.districtOptions.push({
            ...item,
            name: `${item.prefix} ${item.name}`,
          })
        })
      }
    },
    async loadWards(districtID = null) {
      let param = {}
      if (districtID) {
        param = {
          limit: 200,
          district_id: districtID,
        }
      }
      const res = await this.mixGet('/wards', param)
      if (res.status) {
        // eslint-disable-next-line array-callback-return
        res.data.items.map(item => {
          this.wardsOptions.push({
            ...item,
            name: `${item.prefix} ${item.name}`,
          })
        })
      }
    },
    // load province, district, ward GHN
    async loadProvinceGHN() {
      const res = await this.mixGet('/ghn/get_province', { limit: 64 })
      if (res.status) {
        const temp = []
        // eslint-disable-next-line array-callback-return
        res.data.map((item, index) => {
          temp.push({
            id: item.ProvinceID,
            name: item.ProvinceName,
            slug: this.convertToSlug(item.ProvinceName),
            NameExtension: item.NameExtension,
          })
          const find = temp[index].NameExtension.includes(this.model.customer.province_name)
          if (find) {
            this.modelShipping.province_id = temp[index].id
          }
        })
      }
    },
    async loadDistrictGHN() {
      const res = await this.mixGet('/ghn/get_district', { limit: 200, province_id: this.modelShipping.province_id })
      if (res.status) {
        const temp = []
        // eslint-disable-next-line array-callback-return
        res.data.map((item, index) => {
          temp.push({
            id: item.DistrictID,
            name: item.DistrictName,
            slug: this.convertToSlug(item.DistrictName),
            NameExtension: item.NameExtension ? item.NameExtension : [],
          })
          const find = temp[index].NameExtension ?? temp[index].NameExtension.includes(this.model.customer.district_name)
          if (find) {
            this.modelShipping.district_id = temp[index].id
          }
        })
        // const slugDistrict = this.convertToSlug(this.model.customer.district_name)
        // const find = temp.includes(x => x.slug === slugDistrict)
        // this.modelShipping.district_id = find.id
      }
    },
    async loadWardsGHN() {
      const res = await this.mixGet('/ghn/get_ward', { limit: 200, district_id: this.modelShipping.district_id })
      if (res.status) {
        const temp = []
        // eslint-disable-next-line array-callback-return
        res.data.map((item, index) => {
          temp.push({
            id: item.WardCode,
            name: item.WardName,
            slug: this.convertToSlug(item.WardName),
            NameExtension: item.NameExtension,
          })
          const find = temp[index].NameExtension ?? temp[index].NameExtension.includes(this.model.customer.wards_name)
          if (find) {
            this.modelShipping.wards_id = temp[index].id
          }
        })
        // const slugWards = this.convertToSlug(this.model.customer.wards_name)
        // const find = temp.find(x => x.slug === slugWards)
        // this.modelShipping.wards_id = find.id
      }
    },
    async getFeeShip() {
      let setweight = 0
      let setheight = 0
      let setlenght = 0
      let setwidth = 0
      // eslint-disable-next-line array-callback-return
      this.model.products.map(item => {
        setweight += item.weight * item.quantity
        if (item.height > setheight) setheight = item.height
        if (item.lenght > setlenght) setlenght = item.lenght
        if (item.width > setwidth) setwidth = item.width
      })
      this.infoOrder = {
        ...this.infoOrder,
        customerName: this.model.customer.fullname,
        customerPhone: this.model.customer.phone,
        customerAddress: this.model.customer.address,
        cod: this.model.payment_method.id === 1 ? this.totalPriceFinal : 0,
        weight: setweight * 1000,
        height: setheight,
        lenght: setlenght,
        width: setwidth,
      }
      await this.loadProvinceGHN()
      await this.loadDistrictGHN()
      await this.loadWardsGHN()
      this.getFeeGHN()
      this.getFeeGHTK()
      this.shippingHidden = false
    },
    setShipping(index) {
      this.feeShippingSelected = this.feeShip[index]
      this.fee = this.feeShip[index].fee
    },
    async getFeeGHN() {
      const params = {
        to_ward_code: this.modelShipping.wards_id,
        to_district_id: this.modelShipping.district_id,
        weight: 300,
        width: 15,
        length: 15,
        height: 5,
        insurance_value: 1000000,
        service_type_id: 2,
        from_district_id: 1443,
      }
      const res = await this.mixGet('/ghn/shipping_fee', params)
      if (res.status) {
        this.feeShip[0].fee = res.data.total
      }
    },
    async getFeeGHTK() {
      const params = {
        pick_province: 'Hồ Chí Minh',
        pick_district: 'Tân Bình',
        province: this.model.customer.province_name,
        district: this.model.customer.district_name,
        address: this.model.customer.address,
        weight: 300,
        deliver_option: 'none',
        value: 1000000,
      }
      const res = await this.mixGet('/ghtk/get_shipment_fee', params)
      if (res.status) {
        this.feeShip[1].fee = res.data.fee
      }
    },
    // eslint-disable-next-line consistent-return
    async handlerSubmitOrder() {
      if (!this.model.customer) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-center',
          props: {
            title: 'Error!',
            icon: 'CheckCircleIcon',
            variant: 'danger',
            text: 'Vui lòng chọn khách hàng',
          },
        })
        return false
      }
      if (!this.model.payment_method) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-center',
          props: {
            title: 'Error!',
            icon: 'CheckCircleIcon',
            variant: 'danger',
            text: 'Vui lòng chọn phương thức thanh toán',
          },
        })
        return false
      }
      if (this.model.products.length <= 0) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-center',
          props: {
            title: 'Error!',
            icon: 'CheckCircleIcon',
            variant: 'danger',
            text: 'Vui lòng chọn sản phẩm',
          },
        })
        return false
      }
      const addressJs = {
        id: this.model.customer.id_number,
        address: this.model.customer.address,
        fullname: this.model.customer.fullname,
        phone: this.model.customer.phone,
        country_id: 1,
        zip_code: 0,
        is_default: 1,
        address_type: 2,
        province: 1,
        district: 1,
        ward: 1,
        province_name: this.model.customer.province_name,
        province_prefix: '',
        district_name: this.model.customer.district_name,
        district_prefix: '',
        ward_name: this.model.customer.wards_name,
        ward_prefix: '',
      }
      const params = {
        site_id: JSON.parse(localStorage.getItem('siteID')).id,
        storages_id: this.storage.id_number,
        customer_id: this.model.customer.id_number,
        phone: this.model.customer.phone,
        fullname: this.model.customer.fullname,
        address: this.model.customer.address,
        payment_method: this.model.payment_method.name,
        payment_type: this.model.payment_method.id,
        total: this.subTotalPrice,
        order_items: [],
        // shipping_status: this.feeShippingSelected.id,
        shipping_phone: this.model.customer.phone,
        shipping_fullname: this.model.customer.fullname,
        shipping_address: this.model.customer.address,
        shipping_price: this.fee,
        delivery_address_id: this.model.customer.delivery_address_id,
        note: this.model.note ? this.model.note : '',
        surcharge: this.modelSurcharge.list.length > 0 ? JSON.stringify(this.modelSurcharge.list) : '',
        address_json: JSON.stringify(addressJs),
      }
      // if (this.feeShippingSelected.id === 1) {
      //   const temp = {
      //     to_ward_code: this.modelShipping.wards_id,
      //     to_district_id: this.modelShipping.district_id,
      //     weight: this.infoOrder.weight,
      //     length: this.infoOrder.length,
      //     width: this.infoOrder.width,
      //     height: this.infoOrder.height,
      //     insurance_value: totalPriceValue,
      //     service_type_id: 2,
      //     from_district_id: 1442,
      //     note: this.infoOrder.note,
      //   }
      //   params.param_ghn = JSON.stringify(temp)
      // } else {
      //   const temp = {
      //     province: this.model.customer.province_name,
      //     district: this.model.customer.district_name,
      //     ward: this.model.customer.wards_name,
      //     street: null,
      //     address: this.model.customer.address,
      //     weight: this.infoOrder.weight,
      //     deliver_option: 1,
      //     domain_name: localStorage.getItem('siteID').domain_name,
      //     value: totalPriceValue,
      //     pick_address: '51 Yên Thế',
      //     pick_name: 'Luân',
      //     pick_tel: '0987654321',
      //     note: this.infoOrder.note,
      //   }
      //   params.param_ghtk = JSON.stringify(temp)
      // }
      const temp = []
      // eslint-disable-next-line array-callback-return
      this.model.products.map(item => {
        temp.push({
          product_id: item.product_id,
          warehouse_id: item.warehouse_id,
          quantity: item.quantity,
          price: item.price,
          newprice: item.discount_price !== 0 ? item.price - item.discount_price : null,
          product_nm: item.name,
        })
      })
      params.order_items = JSON.stringify(temp)
      const res = await Request.post(
        this.$http,
        `${process.env.VUE_APP_API_URL}/v2/order`,
        params,
      )
      if (res.status === 200) {
        if (res.data.status) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Congratulation !',
              icon: 'CheckCircleIcon',
              variant: 'success',
              text: 'Tạo đơn hàng thành công',
            },
          })
          this.$router.push('/order/list')
        } else {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Opps! Something wrong',
              icon: 'AlertOctagonIcon',
              variant: 'danger',
              text: String(this.showError(res.data.error, ',')),
            },
          })
        }
      }
    },
    async handlerSubmitAddress() {
      this.model.customer = {
        ...this.model.customer,
        address: `${this.addressShipping.address}, ${this.addressShipping.wards.name}, ${this.addressShipping.district.name}, ${this.addressShipping.province.name}`,
        address_full: `${this.addressShipping.address}, ${this.addressShipping.wards.name}, ${this.addressShipping.district.name}, ${this.addressShipping.province.name}`,
        email: this.addressShipping.email,
        fullname: this.addressShipping.fullname,
        phone: this.addressShipping.phone,
        province_name: this.addressShipping.province.name,
        district_name: this.addressShipping.district.name,
        wards_name: this.addressShipping.wards.name,
        province: this.addressShipping.province.id,
        district: this.addressShipping.district.id,
        ward: this.addressShipping.wards.id,
      }
      const params = {
        site_id: JSON.parse(localStorage.getItem('siteID')).id_number,
        customer_id: this.model.customer.id_number,
        address: this.addressShipping.address,
        fullname: this.addressShipping.fullname,
        phone: this.addressShipping.phone,
        province: this.addressShipping.province.id,
        district: this.addressShipping.district.id,
        ward: this.addressShipping.wards.id,
        country_id: 254,
        is_default: 0,
        address_type: 0,
      }
      const res = await this.mixPost('/delivery_address', params)
      if (res.status) {
        this.model.customer = {
          ...this.model.customer,
          delivery_address_id: res.data.id,
        }
      }
    },
    handleAddPay() {
      this.modelSurcharge.list.push(
        {
          id: (new Date()).getTime(),
          money: null,
          name: null,
        },
      )
    },
    opBank(index) {
      this.modelAddSurcharge.show = true
      this.modelAddSurcharge.index = index
    },
    handleDelete(index) {
      this.modelSurcharge.list.splice(index, 1)
    },
    handleSelectedSurcharge(data, index) {
      const temp = JSON.parse(JSON.stringify(this.modelSurcharge.list))
      const find = temp.find(x => x.id === data.id)
      if (!find) {
        this.modelSurcharge.list[index] = data
      }
      this.modelSurcharge.list = [...new Set(this.modelSurcharge.list)]
    },
    async getSurcharge(index = null) {
      const res = await this.mixGet('/setting/surcharge', {})
      if (res.status) {
        const temp = JSON.parse(res.data.value)
        this.surchargeOptions = temp
        if (index !== null) {
          this.modelSurcharge.list[index] = temp[0] ? temp[0] : null
        }
      }
    },
    async addSurcharge() {
      const bankList = JSON.parse(JSON.stringify(this.surchargeOptions))
      const { index } = this.modelAddSurcharge
      bankList.unshift({
        id: (new Date()).getTime() * Math.random(),
        name: this.modelAddSurcharge.name,
        money: this.modelAddSurcharge.money,
      })
      const params = {
        key: 'surcharge',
        value: JSON.stringify(bankList),
      }
      const res = await this.mixPut('/setting/surcharge', params)
      if (res.status) {
        this.modelAddSurcharge.show = false
        this.modelAddSurcharge = JSON.parse(this.modelbankJson)
        this.getSurcharge(index)
      }
      if (res.error && res.error.setting && res.error.setting === 'Setting not exist') {
        const res2 = await this.mixPost('/settings', params)
        if (res2.status) {
          this.modelAddSurcharge.show = false
          this.modelAddSurcharge = JSON.parse(this.modelbankJson)
          this.getSurcharge(index)
        } else {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Opps! Something wrong',
              icon: 'AlertOctagonIcon',
              variant: 'danger',
              text: String(this.showError(res.data.error, ',')),
            },
          })
        }
      }
    },
    okSurcharge() {
      this.modelSurcharge.is_use = true
      this.totalSurchargeFinal = this.totalSurcharge
      this.modalSurcharge = false
      this.totalPrice()
    },
    // async getDetailCustomer() {
    //   const res = await this.mixGet(`/customer/${this.model.customer.id}`, { site_id: localStorage.getItem('siteID').id_number })
    //   if (res.status) {
    //   }
    // },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.custom-good-table .vgt-table {
  font-size: 14px;

  thead th {
    vertical-align: middle;
    text-align: center;
    padding-right: 0.75em;
    white-space: nowrap;
  }
  td {
    vertical-align: middle;
  }
}

.modal .modal-footer {
  justify-content: space-between;
  display: block;
}

.v-select.vs--open {
  ul li {
    border-bottom: 1px solid #ccc;
  }
}
</style>

<style lang="sass" scoped>
.purchasing-order
  &__item
    // &:not(:last-child)
    //   margin-bottom: 24px

    .widget
      flex-basis: 300px
      max-width: 300px

      .card-body
        max-height: 360px
        overflow-y: auto

        &::-webkit-scrollbar
          width: 4px

        &::-webkit-scrollbar-track
          background: var(--gray)

        &::-webkit-scrollbar-thumb
          background: var(--secondary)

        &::-webkit-scrollbar-thumb:hover
          background: var(--primary)

  &__product-info
    display: flex
    flex-wrap: wrap
    justify-content: space-between

    .left
      flex: 0 0 360px
      max-width: 360px

    .right
      flex: 0 0 400px
      max-width: 400px

      .block
        display: grid
        gap: 8px

        &:not(:last-child)
          border-bottom: 1px dashed #E8EAEB
          margin-bottom: 16px
          padding-bottom: 16px

        .d-flex
          gap: 16px

          span
            max-width: calc(50% - 8px)

        .form-control
          border: none
          border-bottom: 1px solid #D3D5D7
          border-radius: 0
          height: auto
          padding: 4px 8px
          box-shadow: none
          text-align: right
          max-width: 120px

.customer-info
  .info-content
    display: flex
    justify-content: space-between
    margin-bottom: 24px

    .right
      display: grid
      gap: 8px
      flex: 0 0 280px
      max-width: 280px

      &.bordered
        border: 1px dashed var(--gray)
        padding: 12px

.shipping-info
  display: grid
  grid-template-columns: 350px 1fr
  gap: 20px

  &-card
    width: 100%
    border: 1px dashed
    height: 100%
    padding: 16px 24px
    background: #F4F4F5
    box-sizing: border-box
    border-color: #A3A8AF
    border-radius: 5px

  &-content
    .noti-card
      display: flex
      gap: 16px

      > .d-flex
          padding: 18px 0px 0px 24px

  .css-shipping
    border: 1px solid #ccc
    border-radius: 4px
    cursor: pointer

    &:hover,
    &.active
      border-color: var(--success)
</style>
